/**
 * AndVWordCloud - 词云图组件
 * 基于 Ant Design Charts WordCloud
 */
import React from 'react';
import { WordCloud } from '@ant-design/plots';
import { withBaseChart, parseJsonProp } from '../base/BaseChart';
import type { AndVWordCloudProps } from '../base/types';

const DEFAULT_WORD_CLOUD_DATA = [
  { word: '数据分析', value: 28 },
  { word: '可视化', value: 22 },
  { word: '报表', value: 18 },
  { word: '图表', value: 16 },
  { word: '设计器', value: 14 },
  { word: '统计', value: 12 },
  { word: '设备', value: 10 },
  { word: '运维', value: 9 },
];

const WordCloudWithBase = withBaseChart<AndVWordCloudProps>(WordCloud, {
  chartType: 'AndVWordCloud',
  defaultHeight: 300,
  defaultData: DEFAULT_WORD_CLOUD_DATA,
});

export const AndVWordCloud: React.FC<AndVWordCloudProps> = (props) => {
  const { textField = 'word', colorField, layout, ...baseProps } = props;

  const chartProps: Record<string, unknown> = {
    ...baseProps,
    textField,
  };

  if (colorField) chartProps.colorField = colorField;

  const layoutConfig = parseJsonProp(layout);
  if (layoutConfig !== undefined) chartProps.layout = layoutConfig;

  return <WordCloudWithBase {...chartProps} />;
};

export type { AndVWordCloudProps };
export default AndVWordCloud;
